import { render, staticRenderFns } from "./iossManageList.vue?vue&type=template&id=df21498a&scoped=true"
import script from "./iossManageList.vue?vue&type=script&lang=js"
export * from "./iossManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df21498a",
  null
  
)

export default component.exports